import { __awaiter } from "tslib";
import apiClient, { getApiHeaders } from './apiClient';
export const submitContactFeedback = (contactId, data) => __awaiter(void 0, void 0, void 0, function* () {
    yield apiClient.patch(`/v3/show-feedback/${contactId}`, data, {
        headers: getApiHeaders(),
    });
});
